// src/components/ReportsList.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ReportsList = () => {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    fetch(`${backendUrl}/reports-list`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched reports:", data);
        setReports(data);
      })
      .catch((err) => console.error("Failed to fetch reports:", err));
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <h2>Available Reports</h2>
      <ul>
        {reports.map((report, index) => (
          <li key={index}>
            <Link to={`/report/${report}`} target="_blank">
              {report}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReportsList;
